import React, { } from "react";
import Slider from "react-slick";
import "./shop-by-categories-slider.scss";

const ShopByCategoriesSlider = ({ categoryImages = [], navigate }) => {
  let ExcitingSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 9,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToScroll: 3,
          slidesToShow: 3.5,
        },
      },
      {
        breakpoint: 812,
        settings: {
          arrows: false,
          slidesToScroll: 3,
          slidesToShow: 3.8,
        },
      },
      {
        breakpoint: 667,
        settings: {
          arrows: false,
          initialSlide: 0.5,
          slidesToScroll: 3,
          slidesToShow: 3.8,
        },
      },

    ],
  };

  const handleCategoryOnClick = (categoryImages, navigate) => {
    const encodedValue = encodeURIComponent(categoryImages?.categoryName);
    navigate(`/category?name=${encodedValue}`);
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <Slider {...ExcitingSettings} className="shop-by-categories-slider-kl">
              {categoryImages.map((category, index) => (
                <div onClick={() => handleCategoryOnClick(category, navigate)} className="shop-by-categories-items-kl" key={index}>
                  <div className="shop-by-categories-items-container-kl">
                    <div className="shop-by-categories-img-container-kl">
                      <img className="shop-by-categories-items-img-kl" src={category?.value ?? ""} alt={`Exciting offer ${index + 1}`} />
                    </div>
                    <p className="shop-by-categories-items-title-kl">
                      {category?.categoryName ?? ""}
                    </p>
                    <div className="overplay-kl"></div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopByCategoriesSlider;
